<template>
<div style="margin: 0; padding: 0" id="wrapper">
  <div>
    <!-- Lobby para el operador -->
     <div id="logo_chat_nuevo">
           <img style="margin: 20px" src="https://imagenes.leon.gob.mx/logo-leon.svg" width="150px" >
        </div>
     
    <div class="text-right" style="width:90%">
      <!-- <ul>
        <li v-for="operator in onLineOperators" :key="operator.key"> 
          {{operator}}
        </li>
      </ul> -->
      <button class="btn btn-danger" v-on:click="closeSession">Cerrar Sesión:
        <strong>{{correoElectronico}}</strong>

      </button>
    </div>

    <br>

    <main role="main" class="container">
      <table class="table stripped listado">
        <thead style="background-color:white;">
          <tr v-if="UsersInLobby.length">
            <th scope="col"></th>
            <th scope="col">Tiempo espera</th>
            <th scope="col">Ciudadano</th>
            <th scope="col">Origen</th>
            <th scope="col">Atendido por</th>
            <th scope="col">IP</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in UsersInLobby" :key="usuario.key">
            <th v-if="usuario.username">
              <div v-if="usuario.status==0">
                <span class="badge badge-primary">En espera</span>
              </div>
              <div v-if="usuario.status==1">
                <span class="badge badge-success">En Atención</span>
              </div>
              <div v-if="usuario.status==3">
                <span class="badge badge-danger">Operador se desconecto</span>
              </div>
              <div v-if="usuario.status==4">
                <span class="badge badge-secondary">Ciudadano se desconectó</span>
              </div>
            </th>
            <td v-if="usuario.username">
              <ciudadano-row
                v-if="usuario.status==0"
                v-bind:hora="usuario.date"
                v-bind:estatus="usuario.status"
                v-bind:keyCiudadano="usuario.key"
                v-on:cancelarpeticion="expiredTime"
              />
            </td>
            <td v-if="usuario.username">{{usuario.username}}</td>
            <td v-if="usuario.username">{{usuario.origen}}</td>
            <td v-if="usuario.username">{{usuario.operatorId}}</td>
            <td v-if="usuario.username">{{usuario.ipAddress}}</td>
            <td v-if="usuario.username">
              <router-link
                :to="{ name: 'Chat', params: { keyId: usuario.key, email:usuario.email, opsess:OpSession, ipAddress:usuario.ipAddress }}"
              >
                <button
                  style="background-color:#E39032; border:none;"
                  type="button"
                  class="btn btn-success" 
                  v-if="usuario.status==0 || usuario.status==3 || usuario.operatorId==correoElectronico">Atender</button>
              </router-link>
            </td>
          </tr>
          <th colspan="4" style="border:none;" v-if="!UsersInLobby.length">
            <div class="alert alert-primary" role="alert">No hay ciudadanos en espera ...</div>
          </th>
        </tbody>
      </table>
    </main>
  </div>
</div>
</template>

<script>
import firebase from "firebase";
import CiudadanoRow from "./CiudadanoRow";

export default {
  name: "Lobby",
  components: {
    "ciudadano-row": CiudadanoRow
  },
  props: {
    msg: String
  },
  data() {
    return {
      users: null,
      name: null,
      opsess: null,
      ops:null,
      index: null,
      user: null,
      backgroundcolor: "#EEEEED",
      onLineOperators:[],
      correoElectronico:null
    };
  },
  methods: {
    getAllOnLineOperators(){
      var self = this;
      var ref = firebase.database().ref(`users/online/`)
       ref.on("value", function(snapshot) {
         snapshot.forEach((element)=>{
           let email = element.val()
           self.onLineOperators.push({
             email: email.email
           }) 
         })
       })  
    },
    /* el componente duró mas de lo esperado, cancelar la peticion en firebase*/
    expiredTime(userKey){
      firebase.database().ref(`lobby/users/${userKey}`).update({
              'status': "2"
        });
    },
    RemoveAllChatMessages(){
     firebase.database().ref(`chats/current`).remove();
    },

    RemoveAllActiveSessions(){
      let self = this
      var ref = firebase.database().ref(`lobby/users/`)
       ref.on("value", function(snapshot) {
         /* recorre todo el lobby y las finaliza*/
         snapshot.forEach((element)=>{
           firebase.database().ref(`lobby/users/${element.key}`).update({
              'status': "2"
            });
         })
        //  self.RemoveAllChatMessages()
       })  
    },
    signOut(){
      firebase.auth().signOut().then(function() {
        console.log(":(")
          localStorage.removeItem("opSess");         
      })
    },
    async removeAllUsers(){
      let imTheLastOperator = await this.ImTheLast();
      let Operators = imTheLastOperator.val()
      let operatorsOnLine = imTheLastOperator.numChildren();
      imTheLastOperator.forEach(element => {
        if(element.val().loggIn==false || (element.val().email==undefined)){
          if(element.key!=undefined){
            firebase.database().ref(`users/online/${element.key}`).remove();
          }
        }
      })
      
      if (parseInt(operatorsOnLine) == 1) {
        const RemoveAllActiveSessions  = await this.RemoveAllActiveSessions();
        const RemoveAllChatMessages  = await this.RemoveAllChatMessages();
      } 
      firebase.database().ref(`users/online/${this.ops}`).remove();
      const signOut = await this.signOut();
      this.$router.back();
      location.reload()
      //this.$router.resolve({name: 'Acceso'}).href
       //this.$router.push({name: "Acceso"});
    },

    closeSession() {
      this. removeAllUsers()
      /*let self = this;
       self.ImTheLast()
            .then(snap => {
              let Operators = snap.val()
              let operatorsOnLine = snap.numChildren();
              snap.forEach(element => {
               if(element.val().loggIn==false || (element.val().email==undefined)){
                if(element.key!=undefined){
                     firebase.database().ref(`users/online/${element.key}`).remove();
                }
               }
              })
               firebase.database().ref(`users/online/${self.ops}`).remove();
                if (parseInt(operatorsOnLine) == 1) {
                  const t  = await self.RemoveAllActiveSessions();
                } 
                 firebase.auth().signOut().then(function() {
                  localStorage.removeItem("opSess");         
                  })
                self.$router.push({
                 name: "Acceso"
               });
            })*/
    },
    startAudio() {
      //let AudioURL = '../../assets/sounds/notification_sound.mp3'
      //let AudioURL = '~@/assets/sounds/notification_sound.mp3'
      /*let AudioURL = "../assets/sounds/notification_sound.mp3";
      let myLog = new File([""], AudioURL);
      if (myLog.exists) {
        console.log("yes");
      } else {
        console.log("no");
      }
      let audio = new Audio(require(AudioURL));
      audio.play();*/
    },

    onShowUsersOnLobby() {
      var self = this;
      var ref = firebase.database().ref("lobby/users");
      /* cambio un valor del lobby - se agrego o se cambio status */
      /* https://stackoverflow.com/questions/47281746/vue-update-component-data-from-vue-instance */
      ref.on("value", function(snapshot) {
        /* Identificar que tipo de cambio */
        /* Detener timer para los componentes tomados */
        /* reproducir sonido*/
        //self.startAudio()
        self.users = [];
        snapshot.forEach(element => {
          if(element.key != "undefined"){
            self.users.push({
              username: element.val().username,
              ipAddress: element.val().ip,
              email: element.val().email,
              date: element.val().date,
              status: element.val().status,
              key: element.key,
              origen: element.val().origen,
              operatorId: element.val().operatorId
            });
          }
        });
      });
    },
    /* close or refresh */
    onOperatorClosesBrowser() {
      firebase
        .database()
        .ref(`users/online/${this.ops}`)
        .remove();
      localStorage.LEO_REI = 1;
    },
    ImTheLast() {
      /* Busca la cantidad de operadores online */
      return new Promise(function(resolve, reject) {
        return  firebase.database().ref("users/online").once('value')
        .then(function(snapshot) {
          resolve(snapshot);
        })
         .catch(function(error) {
            reject(error);
        })

        });
         /*ref.on("value", function(snapshot) {
            resolve(snapshot);
          })
          .catch(function(error) {
            reject(error);
          });*/

    },
    listenChangesMyUser(){
     let self=this
     if(this.ops!=undefined){
      var ref = firebase.database().ref().child(`users/online/${this.ops}`)
        ref.on("value", function(snapshot) {
          if(snapshot.val()!=undefined){
           if(snapshot.val().loggIn==false){
             self.closeSession()
           }
          }
          
        })
      }
  },

  },
  computed: {
    /* trae todos los ciudadanos esperando chatear */
    UsersInLobby: function() {
      return this.users.reverse().filter(u => {
        return u.status != 2;
      });
    },
    OpSession: function() {
      return this.ops;
    }
  },

  
  created() {
    let self = this;
    self.correoElectronico = "";
    this.ops = this.$route.params.opsess;
    self.listenChangesMyUser();
    firebase.database().ref().child(`users/online/${this.ops}`).onDisconnect().update({loggIn:false})
    window.addEventListener("beforeunload", this.onOperatorClosesBrowser);
    self.users = [];
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        self.user = user;
        self.correoElectronico = user.email
        if (
          localStorage.LEO_REI != undefined &&
          localStorage.opSess != undefined
        ) {
          //
          firebase
            .database()
            .ref(`users/online/`)
            .push({
              loggIn: true,
              email: user.email
            })
            .then(sessionId => {
              self.ops = sessionId.key;
              localStorage.opSess = sessionId.key;
              localStorage.removeItem("LEO_REI");
            });
        }
        self.onShowUsersOnLobby();
      } else {
        self.$router.push({
          name: "Acceso"
        });
      }
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#logo_chat_nuevo img{
    width: 195px;
   
  }
#wrapper {
  margin: 0;
  padding: 0px 10px;
  /* background-color: blueviolet; */
  width: 100%;
}

.container {
  font-family: "Noto Sans JP", sans-serif;
}
.listado {
  font-size: 14px;
}

button {
  font-family: "Noto Sans JP", sans-serif;
  font-size: 13px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>